import axios from 'axios';

const API_URL = '/orders/';

// Get all orders
const getOrders = async (token, params = {}) => {
    const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
      params,
  };
  const response = await axios.get(API_URL, config);
  return response.data;
};

const getUnpaidOrders = async (token, params = {}) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
    params,
};
const response = await axios.get(API_URL + "unpaid", config);
return response.data;
};

// Get order by id
const getOrder = async (token, orderId) => {
    const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };
  const response = await axios.get(`${API_URL}${orderId}`, config);
  return response.data;
};

const getOrderShippingLabel = async (token, orderId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  };
  const response = await axios.get(`${API_URL}${orderId}/shipping-label`, config);
  return response.data;
};

const getOrderInvoice = async (token, orderId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  };
  const response = await axios.get(`${API_URL}${orderId}/invoice`, config);
  return response.data;
};

const getOrderPublic = async (orderId) => {
  const response = await axios.get(`${API_URL}public/${orderId}`);
  return response.data;
};

// Create a new order
const createOrder = async (token, orderData) => {
    const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };
  const response = await axios.post(`${API_URL}create`, orderData, config);
  return response.data;
};

// Initiate Stripe payment session
const initiatePayment = async (orderData) => {
  const response = await axios.post(`${API_URL}initiate-payment`, orderData);
  return response.data;
};

const toggleStatus = async (token, data) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
};
  const response = await axios.post(`${API_URL}toggle-status`, data, config);
  return response.data;
};

const contactUs = async (contactData) => {
  const response = await axios.post(`${API_URL}contact-us`, contactData);
  return response.data;
};

const checkPaymentStatus = async (orderId) => {
  const response = await axios.get(`${API_URL}check-payment/${orderId}`);
  return response.data;
};

const resendEmail = async (id) => {
  const response = await axios.post(`${API_URL}resend-email/${id}`);
  return response.data;
};

const retryFulfillment = async (token, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(`${API_URL}retry-fulfillment/${id}`, {}, config);
  return response.data;
};

// Fetch shipping labels for selected orders
const getShippingLabels = async (token, ids) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(`${API_URL}shipping-labels`, { ids }, config);
  return response.data;
};

const getReviewObject = async (reviewId) => {
  const response = await axios.get(`${API_URL}reviews/${reviewId}`);
  return response.data;
};

const postReview = async (review_data) => {
  const response = await axios.post(`${API_URL}reviews/${review_data.review_data._id}`, review_data);
  return response.data;
};

const deleteReview = async (token, reviewId) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.delete(`${API_URL}reviews/${reviewId}`, config);
  return response.data;
}

const updateReviewReply = async (token, data) => {
  const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(`${API_URL}reviews-edit/${data.reviewId}`, {reply: data.reply}, config);
  return response.data;
}

const getCustomInvoice = async (data) => {
  const response = await axios.post(`${API_URL}create-custom-invoice`, data);
  return response.data;
};

const exportOrders = async (ids) => {
  const response = await axios.post(`${API_URL}excel`, { ids }, { responseType: 'blob' });
  return response.data;  // This will return a Blob object
};


const orderService = {
  getOrders,
  getOrder,
  getOrderShippingLabel,
  getOrderInvoice,
  createOrder,
  initiatePayment,
  getOrderPublic,
  toggleStatus,
  contactUs,
  resendEmail,
  retryFulfillment,
  getUnpaidOrders,
  getShippingLabels,
  exportOrders,
  getCustomInvoice,
  getReviewObject,
  postReview,
  deleteReview,
  updateReviewReply,
  checkPaymentStatus
};

export default orderService;
